export default __webpack_public_path__ + "static/data-more-about-img2-fdb8517852894ce95f5b094fc0cc11d1.png";